import React from 'react';
import styles from './content.module.scss';

export interface ContentProps {
  children: React.ReactNode;
}

const Content: React.FC<ContentProps> = ({ children }) => (
  <div className={styles.root}>{children}</div>
);

export default Content;
